import Swiper from 'swiper/bundle'

const detailSlider = new Swiper('.js-detail-slider .swiper-container', {
  loop: true,
  grabCursor: true,
  slidesPerView: 1.2,
  centeredSlides: true
})